import React from 'react';
import { MODERATION_TYPE, MODERATION_TYPE_LABELS } from '../../constants/Constants';

const ModerationTypeSelector = ({ value, onChange ,showErrors }) => {
  const hasError = showErrors && !value;
  return (
    <div className={`field mb-5 ${hasError ? 'field-validation has-error' : ''}`}>
      <label className="label" style={{
          color: '#363636',
          display: 'block',
          fontSize: '1rem',
          fontWeight: '700',
          marginBottom: '0.5rem'
        }}>
        Select the type of moderation you would like <span className="has-text-danger">*</span>
      </label>
      <div className="control">
        <div className="field is-grouped">
          <div className="control">
            <label className={`radio ${hasError ? 'has-error' : ''}`} style={{
                fontFamily: "'Open Sans', 'Source Sans 3', Arial, Helvetica, sans-serif",
                fontSize: '1rem',
                fontWeight: 'normal',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}>
              <input
                type="radio"
                name="moderationType"
                value={MODERATION_TYPE.FACE_TO_FACE}
                checked={value === MODERATION_TYPE.FACE_TO_FACE}
                onChange={(e) => onChange(e.target.value)}
                className=""
              />
              {MODERATION_TYPE_LABELS[MODERATION_TYPE.FACE_TO_FACE]}
            </label>
          </div>
          <div className="control">
            <label className={`radio ${hasError ? 'has-error' : ''}`}
            style={{
              fontFamily: "'Open Sans', 'Source Sans 3', Arial, Helvetica, sans-serif",
              fontSize: '1rem',
              fontWeight: 'normal',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}>
              <input
                type="radio"
                name="moderationType"
                value={MODERATION_TYPE.VIRTUAL}
                checked={value === MODERATION_TYPE.VIRTUAL}
                onChange={(e) => onChange(e.target.value)}
                className=""
              />
              {MODERATION_TYPE_LABELS[MODERATION_TYPE.VIRTUAL]}
            </label>
          </div>
        </div>
      </div>
     {showErrors && !value && <span className="is-validation-message">You must choose an option</span>} 
    </div>
  );
};

export default ModerationTypeSelector;